import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { IconButton, Text } from 'react-native-paper';

import { CloseIcon } from '@/assets';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    view: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: theme.colors.primary,
      paddingEnd: 8,
      paddingVertical: 2
    },
    text: { flex: 1, color: theme.colors.onPrimary, paddingHorizontal: 16 }
  });

type Props = {
  label: string;
  onClose: () => void;
};

export const CommentEditorHeader: FC<Props> = ({ label, onClose }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.view}>
      <Text
        variant="bodyLarge"
        style={styles.text}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {label}
      </Text>
      <IconButton
        size={24}
        style={{ margin: 0 }}
        iconColor={theme.colors.onPrimary}
        icon={({ color, size }) => (
          <CloseIcon fill={color} width={size} height={size} />
        )}
        onPress={onClose}
      />
    </View>
  );
};
